<div class="modal-wrapper">
  <div class="modal" [ngClass]="modalConfig.modalType" role="dialog" id="modal-dialog-option" aria-labelledby="dialog-label" aria-modal="true"
    tabindex="-1">
    <div class="modal-header">
      <h4 class="modal-title " tabindex="0" #closeBtnHeader [id]="modalConfig.modalType+'-header'">{{modalConfig.header}}</h4>
      <button id="btn-close-modal reflect" #closeBtn  class="position-absolute" tabindex="-1"  type="button" (click)="close()" aria-label="close modal button">
        <span class="icon icon-cross reflect" aria-label="close modal button" tabindex="0" aria-hidden="true"></span>
        <span class="visually-hidden">close modal</span>
        <span class="access" id="text-close-modal">Close modal </span>
      </button>
    </div>
    <div class="modal-content-text">
      <span class="clear-all" [innerHTML]="modalConfig.content"></span>
    </div>
    <div class="clear-all" #samePrdctBtn tabindex="0" >
      <button id="btnPrimary" style="margin-top: 2rem" (click)="primaryBtnClickHandler()" class="btn btn-cta btn-block reflect-btn" type="button" >{{modalConfig.footerPrimaryBtnLabel}}</button>
    </div>
    <div class="clear-all" #antherPrdctBtn tabindex="0" >
      <button id="btnSecondary" style="margin-top: 2rem" (click)="secondaryBtnClickHandler()" class="btn btn-tertiary" type="button" >{{modalConfig.footerSecondaryBtnLabel}}</button>
    </div>
  </div>
</div>